"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _col;

  return {
    root: _defineProperty({
      flexGrow: 1
    }, theme.breakpoints.down('sm'), {
      flexDirection: 'column-reverse'
    }),
    col: (_col = {}, _defineProperty(_col, theme.breakpoints.up('md'), {
      height: '100vh'
    }), _defineProperty(_col, "minHeight", '50vh'), _col),
    asideCol: {},
    contentCol: {
      padding: '1rem 2rem',
      justifyContent: 'space-between',
      flexDirection: 'column',
      flexWrap: 'nowrap'
    },
    contentColInner: {},
    header: {
      width: '100%'
    },
    footer: {
      width: '100%'
    },
    content: {
      width: '100%'
    }
  };
});

var LoginLayout = function LoginLayout(props) {
  var classes = useStyles();
  return _react.default.createElement(_core.Grid, {
    container: true,
    className: classes.root,
    spacing: 0
  }, _react.default.createElement(_core.Grid, {
    className: "".concat(classes.asideCol, " ").concat(classes.col),
    container: true,
    item: true,
    xs: 12,
    md: 6
  }, props.aside), _react.default.createElement(_core.Grid, {
    className: "".concat(classes.contentCol, " ").concat(classes.col),
    container: true,
    item: true,
    xs: 12,
    md: 6
  }, _react.default.createElement(_core.Grid, {
    className: "".concat(classes.header),
    item: true
  }, props.header), _react.default.createElement(_core.Grid, {
    className: "".concat(classes.content),
    item: true
  }, props.content), _react.default.createElement(_core.Grid, {
    className: "".concat(classes.footer),
    item: true
  }, props.footer)));
};

LoginLayout.propTypes = {
  aside: _propTypes.default.node,
  header: _propTypes.default.node,
  footer: _propTypes.default.node,
  content: _propTypes.default.node
};
var _default = LoginLayout;
exports.default = _default;